import type React from 'react';
import { RuleIcon } from '../RuleIcon';

type ModificationItemIconProps = {
  backgroundImageUrl?: string;
  borderColor?: 'border-ds-natural-150' | 'border-ds-primary-300';
  children?: React.ReactNode;
};

export const ModificationItemIcon = ({
  backgroundImageUrl,
  borderColor,
  children,
}: ModificationItemIconProps) => {
  return backgroundImageUrl ? (
    <RuleIcon backgroundImageUrl={backgroundImageUrl} />
  ) : (
    <div className="text-ds-primary-300">
      <RuleIcon borderColor={borderColor}>{children}</RuleIcon>
    </div>
  );
};
